import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var ScrollFieldIntoView = /*#__PURE__*/function (_Component) {
  _inherits(ScrollFieldIntoView, _Component);
  var _super = _createSuper(ScrollFieldIntoView);
  function ScrollFieldIntoView(props) {
    var _this;
    _classCallCheck(this, ScrollFieldIntoView);
    _this = _super.call(this, props);
    _this.createFieldNameRef = _this.createFieldNameRef.bind(_assertThisInitialized(_this));
    _this.onFieldFocus = _this.onFieldFocus.bind(_assertThisInitialized(_this));
    _this.passOnFocusToChild = _this.passOnFocusToChild.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ScrollFieldIntoView, [{
    key: "onFieldFocus",
    value: function onFieldFocus(event) {
      event.preventDefault();
      this.fieldName.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }, {
    key: "createFieldNameRef",
    value: function createFieldNameRef(el) {
      this.fieldName = el;
    }
  }, {
    key: "passOnFocusToChild",
    value: function passOnFocusToChild(child) {
      return /*#__PURE__*/React.cloneElement(child, {
        onFocus: this.onFieldFocus
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _context;
      var children = this.props.children;
      var childrenWithFuncs = _mapInstanceProperty(_context = React.Children).call(_context, children, this.passOnFocusToChild);
      return /*#__PURE__*/React.createElement("div", {
        className: "scroll-field-into-view",
        ref: this.createFieldNameRef
      }, childrenWithFuncs);
    }
  }]);
  return ScrollFieldIntoView;
}(Component);
ScrollFieldIntoView.propTypes = {
  children: PropTypes.node.isRequired
};
export default ScrollFieldIntoView;
//# sourceMappingURL=index.js.map